<template>
  <div 
    class="m-horizontal-0 p-horizontal-0 m-vertical-5 has-col-12 is-grid"
    :fill="false"
    grid
  >
    <div class="is-col-3 has-col-6 is-grid is-aligned-left">
      <div class="is-col-3 is-aligned-left">
        <p>
          <small>
            Début
          </small>
        </p> 
      </div>

      <div class="is-col-3 is-aligned-left">
        <p>
          <small>
            Fin
          </small>
        </p>
      </div>
    </div>
    <div class="is-col-9 has-col-12 is-grid is-aligned-left">
      <div class="is-col-2 is-aligned-left">
        <p>
          <small>
            Montant
          </small>
        </p>
      </div>

      <div class="is-col-3 is-aligned-left">
        <p>
          <small>
            Description
          </small>
        </p>
      </div>

      <div class="is-col-2 is-aligned-left">
        <p>
          <small>
            Réduction
          </small>
        </p>
      </div>

      <div class="is-col-2 is-aligned-left">
        <p>
          <small>
            Prélèvement
          </small>
        </p>
      </div>

      <div class="is-col-3 is-aligned-left">
        <p>
          <small>
            Statut
          </small>
        </p>
      </div>
    </div>
  </div>
</template>
